import React, { Component } from "react";
import HttpClient from "../../libs/http";
import "./index.css";

const http = new HttpClient();
var worker = null

export default class Defcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      level: null,
      message: null
    };
    this.getDefcon = this.getDefcon.bind(this)
    this.backgroundColor = this.backgroundColor.bind(this)
  }

  componentWillMount() {
    this.getDefcon()
    worker = setInterval(this.getDefcon, 60000)
  }

  componentWillUnmount() {
    if (worker) clearInterval(worker)
  }

  async getDefcon() {
    let defcon = await http.GET("/api/pvt/defcon");
    this.setState(defcon);
  }

  backgroundColor() {
    switch (this.state.level) {
      case "critical":
        return "bg-dark-red"
      case "warning":
        return "bg-gold"
      case "info":
        return "bg-dark-blue"
    }
  }

  render() {
    if (!this.state.level) return false;
    return (
      <div id="defcon-info" className={`w-100 mv0 pa2 relative ${this.backgroundColor()}`}>
        <div className="fl w-content ph-2 f4 f3-m f2-l tc absolute defcon-message defcon-message-primary">{this.state.message}</div>
        <div className="fl w-content ph-2 f4 f3-m f2-l tc absolute defcon-message defcon-message-secondary">{this.state.message}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Defcon/index.js